
/* eslint-disable no-underscore-dangle */
import VTextField from 'vuetify/lib/components/VTextField';

// eslint-disable-next-line vue/require-direct-export
export default VTextField.extend({
  name: 'PatchedVTextField',
  data: () => ({
    /**
     * onFocusが再帰実行されているかどうかを示すフラグ。
     */
    _recursiveExecOnFocus: false,
  }),
  methods: {
    // 外部からfocusが呼ばれたとき、もしくはコンポーネント内のinput要素にfocusされたときに
    // 実行されるハンドラー。
    onFocus(e?: Event) {
      if (!this._recursiveExecOnFocus) {
        // 再帰実行フラグを立てる。
        this._recursiveExecOnFocus = true;
        window.requestAnimationFrame(() => {
          // 非同期的にフラグを戻す。
          this._recursiveExecOnFocus = false;
        });
        // super呼び出し。
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        VTextField.options.methods.onFocus.call(this, e);
      }
    },
  },
});
